<template>
  <div class="container">
    Processing Logout:
    <sdx-loading-spinner id="spinner-logout" size="large" sr-hint="Loading. Please wait."></sdx-loading-spinner>
  </div>
</template>

<script>
import loadingSpinnerService from "@/services/loading-spinner.service";
import userService from "@/services/user.service";
import envService from "@/services/env.service";

export default {
  mounted() {
    loadingSpinnerService.show("logout");

    userService.clearUserData()

    let oauth2LogoutUrl = envService.getOAuth2LogoutUrl();

    if (envService.isDevMockEnv()) {
      window.location = oauth2LogoutUrl;
    } else {
      let csrfToken = document.cookie.match('(^|;)\\s*' + 'XSRF-TOKEN' + '\\s*=\\s*([^;]+)')?.pop() || '';
      let csrfTokenInput = document.createElement('input');
      csrfTokenInput.setAttribute('type', 'hidden');
      csrfTokenInput.setAttribute('name', '_csrf');
      csrfTokenInput.setAttribute('value', csrfToken);

      let logoutForm = document.createElement('form');
      logoutForm.setAttribute('method', 'post');
      logoutForm.setAttribute('action', oauth2LogoutUrl);
      logoutForm.appendChild(csrfTokenInput);

      document.body.appendChild(logoutForm);

      logoutForm.submit();
    }
  }
};
</script>
<style>
.container {
  display: flex;
  justify-content: center;
  flex-direction: column;
}
</style>
